import { Storage } from '@dvs-angular/storage';

import { TokenService } from './token.service';
import { TokenProvider } from './token-provider';
import { TokenRepository } from './token.repository';
import { ConfigService } from './config.service';

export function tokenServiceFactory(
  storage: Storage,
  tokenRepository: TokenRepository,
  config: ConfigService
) {
  const tokenStorageName = config.getTokenStorageName();
  const refreshTokenStorageName = config.getRefreshTokenStorageName();

  const token: TokenProvider = new TokenProvider(tokenStorageName, storage);
  const refreshToken: TokenProvider = new TokenProvider(refreshTokenStorageName, storage);

  return new TokenService(token, refreshToken, tokenRepository, config);
}
